import { styled } from 'styled-components';

export const WizardResultsTableFooter = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.sizing.medium};
  padding-top: ${({ theme }) => theme.sizing.medium};

  > * {
    flex: 1;
  }

  label {
    ${({ theme }) => theme.typography.bodyMedium}
  }
`;
WizardResultsTableFooter.displayName = 'WizardResultsTableFooter';

export const WizardResultsSummaryStats = styled.div`
  margin: 0 ${({ theme }) => theme.sizing.medium}
    ${({ theme }) => theme.sizing.medium};
  display: flex;
  gap: ${({ theme }) => theme.sizing.medium};

  > div {
    display: flex;
    gap: ${({ theme }) => theme.sizing.medium};
    flex-direction: column;
    width: 50%;
    max-width: 500px;
    max-height: 175px;
    overflow: hidden;
  }

  > div:last-child {
    max-width: 590px;
  }
`;
WizardResultsSummaryStats.displayName = 'WizardResultsSummaryStats';

export const WizardResultsSummaryStatsColumn = styled.div`
  h3 {
    ${({ theme }) => theme.typography.headingMedium}
    color: ${({ theme }) => theme.colours.ink.primary.main};
  }

  > div {
    display: flex;
    gap: ${({ theme }) => theme.sizing.medium};
    padding-top: ${({ theme }) => theme.sizing.small};
    flex-direction: row;
    border: ${({ theme }) =>
      `1px solid ${theme.colours.canvas.secondary.main}`};
    padding: ${({ theme }) => theme.sizing.medium};
    flex-wrap: wrap;
    min-height: 163px;
  }
`;
WizardResultsSummaryStatsColumn.displayName = 'WizardResultsSummaryStatsColumn';

export const WizardResultsSummaryStatsColumnHeader = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
`;
WizardResultsSummaryStatsColumnHeader.displayName =
  'WizardResultsSummaryStatsColumnHeader';
